export default __webpack_public_path__ + "static/media/dFile1.7e9e2ac5.jpg";